import gql from "graphql-tag";

const ListObjectivesQuery = gql`
  query listObjectives(
    $activeStructure: String
    $activeGroup: String!
    $idUserRecipient: String
    $forRecipient: Boolean
    $statusFilter: [StatusFilter]
  ) {
    listObjectives(
      activeStructure: $activeStructure
      activeGroup: $activeGroup
      idUserRecipient: $idUserRecipient
      forRecipient: $forRecipient
      statusFilter: $statusFilter
    ) {
      Items {
        id
        title: sort2
        numKeepGoing
        numThinkAbout
        description
        labels {
          value
          description
        }
      }
    }
  }
`;

export default ListObjectivesQuery;
